import { HBBTV_CONST } from '../constants/constants';

const getApp2AppLocalBaseURL = () => {
    const obj = document.getElementById(HBBTV_CONST.HBBTV_CS_MANAGER_ID);
    if(obj && obj.getApp2AppLocalBaseURL){
        return obj.getApp2AppLocalBaseURL();
    }
    return null;
};

const getApp2AppRemoteBaseURL = () => {
    const obj = document.getElementById(HBBTV_CONST.HBBTV_CS_MANAGER_ID);
    if(obj && obj.getApp2AppRemoteBaseURL){
        return obj.getApp2AppRemoteBaseURL();
    }
    return null;
};

const getInterDevSyncURL = () => {
    const obj = document.getElementById(HBBTV_CONST.HBBTV_CS_MANAGER_ID);
    if(obj && obj.getInterDevSyncURL){
        return obj.getInterDevSyncURL();
    }
    return null;
};

const getAppLaunchURL = () => {
    const obj = document.getElementById(HBBTV_CONST.HBBTV_CS_MANAGER_ID);
    if(obj && obj.getAppLaunchURL){
        return obj.getAppLaunchURL();
    }
    return null;
};

const discoverCSLaunchers = (onCSDiscovery = (csLaunchers) => { console.log('discoverCSLaunchers', csLaunchers) }) => {
    const obj = document.getElementById(HBBTV_CONST.HBBTV_CS_MANAGER_ID);
    if(obj && obj.discoverCSLaunchers){
        obj.discoverCSLaunchers(onCSDiscovery);
        return;
    }
    console.log('Unable to launch discoverCSLaunchers');
};



export { getApp2AppLocalBaseURL, getApp2AppRemoteBaseURL, getInterDevSyncURL, getAppLaunchURL, discoverCSLaunchers }